var map = {
	"./_access_denied.svg": "6d2f",
	"./_add.svg": "1b9c",
	"./_add_hover.svg": "f3e2",
	"./_add_note.svg": "2090",
	"./_add_person.svg": "a275",
	"./_added.svg": "c715",
	"./_attach.svg": "a043",
	"./_attach_left.svg": "111b",
	"./_attach_right.svg": "5231",
	"./_attach_white.svg": "4b55",
	"./_avatar_placeholder.svg": "d48c",
	"./_back.svg": "80da",
	"./_bookmark.svg": "9b96",
	"./_bookmark_active.svg": "92a5",
	"./_box_appointment.svg": "83b9f",
	"./_box_backup_manager.svg": "a017",
	"./_box_contact.svg": "ba96",
	"./_box_email.svg": "b4f1",
	"./_box_live_chat.svg": "1d4a",
	"./_box_schedule.svg": "f8b1",
	"./_box_setting.svg": "9d84",
	"./_business.svg": "03f8",
	"./_business_admin.svg": "7b9d",
	"./_calendar_small.svg": "93b0",
	"./_calendar_small_primary.svg": "c045",
	"./_case_info.svg": "4534",
	"./_chat.svg": "bf39",
	"./_chat_bubble_small.svg": "8888",
	"./_chat_bubble_small_primary.svg": "8a6e",
	"./_check.svg": "e6d6",
	"./_checkbox.svg": "5582",
	"./_checked.svg": "c5a4",
	"./_checked_square.svg": "61f0",
	"./_circle-blue1.svg": "6738",
	"./_circle-blue2.svg": "a452b",
	"./_close.svg": "7cc3",
	"./_close_gray.svg": "0a80",
	"./_close_navy.svg": "62f8",
	"./_close_white.svg": "34cf",
	"./_contact.svg": "38c1",
	"./_create_chat.svg": "c00f",
	"./_cursor_grab.svg": "babf",
	"./_cursor_grabbed.svg": "7e49",
	"./_custom_contact.svg": "bfaf",
	"./_customer_notes.svg": "ae14",
	"./_dashboard.svg": "aef2",
	"./_default_2.svg": "d109",
	"./_dialer_horiz.svg": "0c89",
	"./_disabled_channel.svg": "f624",
	"./_drag.svg": "bd03",
	"./_dragged.svg": "b0c2",
	"./_empty_states_add_contact.svg": "fbb8",
	"./_empty_states_appointment.svg": "2b33",
	"./_empty_states_archive.svg": "7cbe",
	"./_empty_states_case_notes.svg": "595f3",
	"./_empty_states_chat.svg": "7edc",
	"./_empty_states_contacts.svg": "bc53",
	"./_empty_states_customer_notes.svg": "4cc6",
	"./_empty_states_search.svg": "c1a6",
	"./_enterprise.svg": "9bf8",
	"./_export.svg": "2a40",
	"./_faq.svg": "55e2",
	"./_forward.svg": "af34",
	"./_g.svg": "e4e1",
	"./_group_contact.svg": "eac2",
	"./_history_log.svg": "51b8",
	"./_history_log_primary.svg": "2929",
	"./_ic_arrow_dyn_neg.svg": "2846",
	"./_ic_arrow_dyn_pos.svg": "9a52",
	"./_ic_checkbox_off.svg": "79c6",
	"./_ic_checkbox_on.svg": "5d33",
	"./_ic_star.svg": "6c59",
	"./_ic_star_25.svg": "0df8",
	"./_ic_star_50.svg": "6899d",
	"./_ic_star_75.svg": "3b17",
	"./_images.svg": "a714",
	"./_info-icon.svg": "d459",
	"./_invisible_contact.svg": "eb83",
	"./_link.svg": "1a26",
	"./_location.svg": "7511",
	"./_location_pin.svg": "3cdb",
	"./_marked.svg": "ee75",
	"./_members.svg": "ee91",
	"./_members_grey.svg": "1f59",
	"./_menu_horiz.svg": "ebcc",
	"./_menu_horiz_hover.svg": "fee5",
	"./_menu_vert.svg": "0155",
	"./_menu_vert_hover.svg": "13de",
	"./_note_star.svg": "232e",
	"./_notes.svg": "46bc",
	"./_notification.svg": "91f2",
	"./_notifications_profile.svg": "037d",
	"./_notifications_setting.svg": "4315",
	"./_options_menu.svg": "0b0f",
	"./_pigeon_logo.svg": "32ac",
	"./_pin_note.svg": "6a05",
	"./_plus_sign.svg": "2b8b",
	"./_privacy.svg": "ed4b",
	"./_profile.svg": "d08d",
	"./_question_mark.svg": "85f7",
	"./_rating_star.svg": "e8d2",
	"./_rating_star_grey.svg": "d3ae",
	"./_request.svg": "d33b",
	"./_request_solid.svg": "8490",
	"./_requests.svg": "9482",
	"./_search.svg": "7699",
	"./_select.svg": "6214",
	"./_selected.svg": "bf90",
	"./_selected_green.svg": "2133",
	"./_send.svg": "4e83",
	"./_send_contacts.svg": "6a71",
	"./_settings.svg": "46eb",
	"./_star_note.svg": "e983",
	"./_video.svg": "3390",
	"./_video_full_screen.svg": "2fb3",
	"./_video_minimize.svg": "3378",
	"./_video_normalize.svg": "b34d",
	"./_video_off.svg": "8cab",
	"./_video_on.svg": "1210",
	"./_voice_off.svg": "c37a2",
	"./_voice_on.svg": "b032",
	"./_wroking_hours.svg": "a0d2",
	"./app_icon_customer.svg": "d20b",
	"./car_category.svg": "7470",
	"./close_white.svg": "c3dc",
	"./dashboard_info_logo.svg": "727e",
	"./default-white.svg": "b2ac",
	"./email_verified.svg": "952c",
	"./icon_search.svg": "cfa9",
	"./img/delete.svg": "26a0",
	"./img/edit.svg": "66d5",
	"./lamps.svg": "c2f3",
	"./large arrow-icon.svg": "5ab2",
	"./logo.svg": "9b19",
	"./logo_discovery.svg": "b1c8",
	"./main_pic.svg": "2aa9",
	"./minimized.svg": "c9060",
	"./notifications.svg": "4170",
	"./pigeon_logo.svg": "a764",
	"./play.svg": "5830",
	"./point_arrow.svg": "5f1e",
	"./sort-icon-up-down.svg": "fab7",
	"./tour-standing.svg": "4acf",
	"./tour-start.svg": "655a",
	"./tour-wireframe.svg": "172d",
	"./under-construction.svg": "14ff",
	"./video_directory_setup.svg": "8a06",
	"./video_invite_member.svg": "137a",
	"./voice_record.svg": "5d1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";